module.exports = __webpack_public_path__ + "img/button.2602f4e3.png";